import { useLocation } from "react-router-dom";
import LayoutLive from "./LayoutLive";

const ProtectedLayoutLive = () => {
  const notAllowedPaths = ["/orders/mimic"];
  const pathname = useLocation().pathname;

  if (notAllowedPaths.includes(pathname)) {
    return null;
  }
  return <LayoutLive />;
};

export default ProtectedLayoutLive;
